import List from 'settings/auditLogs/List'
import Show from 'settings/auditLogs/Show'

export default {
  List,
  Show,
}
